
import { Subscription } from "@/pages/pricing/hooks/subscription/types";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CalendarClock, Info } from "lucide-react";

interface SubscriptionDetailsProps {
  currentSubscription: Subscription | null;
  isCancelled: boolean;
  daysRemaining: number;
  startDate: string;
  billingOrEndDate: string;
  endDate: Date | null;
}

export function SubscriptionDetails({
  currentSubscription,
  isCancelled,
  daysRemaining,
  startDate,
  billingOrEndDate,
  endDate
}: SubscriptionDetailsProps) {
  return (
    <>
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div className="font-medium">Status:</div>
        <div className={isCancelled ? "text-amber-600 font-medium" : "text-green-600 font-medium"}>
          {isCancelled
            ? 'Cancelled (Pro access until end date)'
            : 'Active'}
        </div>
        
        <div className="font-medium">Plan:</div>
        <div>Pro ($10/month)</div>
        
        <div className="font-medium">Started on:</div>
        <div>{startDate}</div>
        
        <div className="font-medium">
          {isCancelled ? "Pro access until:" : "Next billing:"}
        </div>
        <div className={isCancelled ? "font-medium" : ""}>{billingOrEndDate}</div>
        
        {isCancelled && endDate && (
          <>
            <div className="font-medium">Days remaining:</div>
            <div className="font-bold text-amber-600">{daysRemaining > 0 ? daysRemaining : 0} days</div>
          </>
        )}
      </div>

      {isCancelled && currentSubscription?.end_date && (
        <Alert className="mt-4 bg-amber-50 border-amber-200">
          <CalendarClock className="h-4 w-4 text-amber-600" />
          <AlertTitle className="text-amber-800">Pro access ending soon</AlertTitle>
          <AlertDescription className="text-amber-700">
            Your Pro subscription will remain active until <strong>{new Date(currentSubscription.end_date).toLocaleDateString()}</strong>.
            You'll continue to have access to all Pro features until this date.
            After that, your account will automatically switch to the Free plan.
          </AlertDescription>
        </Alert>
      )}
    </>
  );
}
